// Pages a roadmap item can be linked to (mirrors the PWHL nav tabs). Used by the
// item editor's "Linked page" dropdown, the nav "+N" badges and the in-page overlay.
export const ROADMAP_PAGES = [
    { label: "Standings", to: "/standings" },
    { label: "Schedule", to: "/schedule" },
    { label: "Leaderboards", to: "/team-leaderboards" },
    { label: "Rosters", to: "/rosters" },
    { label: "Lineups", to: "/active-lineup" },
    { label: "Awards", to: "/awards" },
    { label: "Contracts", to: "/contracts" },
    { label: "History", to: "/team-movements" },
    { label: "Trades", to: "/team-trades" },
    { label: "Draft", to: "/team-draft" },
    { label: "Staff", to: "/staff" },
    { label: "Chemistry", to: "/chemistry" },
    { label: "Demographics", to: "/team-demographics" },
    { label: "Milestones", to: "/milestones" },
    { label: "Records", to: "/records" },
    { label: "Rankings", to: "/rankings" },
    { label: "Injuries", to: "/injuries" },
    { label: "Staff Moves", to: "/staff-moves" },
    { label: "Links", to: "/links" },
    { label: "Stories", to: "/stories" },
    { label: "News", to: "/team-news" },
    { label: "Videos", to: "/team-videos" },
    { label: "Chat", to: "/socials" },
    { label: "Roadmap", to: "/roadmap" },
    { label: "Studio", to: "/creator" },
    { label: "Template Studio", to: "/template-studio" },
];

export const roadmapPageLabel = (to) => {
    const base = (to || "").split("?")[0];
    return ROADMAP_PAGES.find((p) => p.to === base)?.label || "";
};

// Count open (non-completed) items per linked page → { "/chemistry": 3, ... }
export const roadmapCountsByPage = (items = []) => {
    const m = {};
    for (const it of items) {
        if (it.completed) continue;
        const p = (it.linked_page || "").split("?")[0];
        if (!p) continue;
        m[p] = (m[p] || 0) + 1;
    }
    return m;
};
